import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { handleAnalytics, Events } from '@foxcorp/delta-web-analytics';
import Timer from 'components/Timer';
import Style from './CountdownBanner.module.scss';

const CountdownBanner = ({ bgImage, countdownTo, handleCountdownEnd, headline, url }) => {
  const { countdown_banner_secondary_cta_label: secondaryCtaText } = window.Language;

  const bgImageStyle = {
    backgroundImage: `url(${bgImage})`,
  };

  const onCountdownBannerClick = () => {
    handleAnalytics({
      event: Events.BANNER_CLICKED,
      payload: {
        page_item_title: headline,
        page_item_type: 'mid banner',
        page_action_location: 'whole banner',
        page_item_state: 'static image',
      },
    });
  };

  const onMoreInfoLinkClick = e => {
    e.stopPropagation();
    handleAnalytics({
      event: Events.BANNER_CLICKED,
      payload: {
        page_item_title: headline,
        page_item_type: 'mid banner',
        page_action_location: 'cta',
        page_button_text: secondaryCtaText,
      },
    });
  };

  return (
    <Link
      to={url}
      className={Style.countdownContainer}
      style={bgImageStyle}
      onClick={onCountdownBannerClick}
    >
      <div className={Style.countdownWrapper}>
        <p className={Style.headline}>{headline}</p>
        <div className={Style.countdownTimer}>
          <Timer countdownTime={countdownTo} setIsActive={handleCountdownEnd} isMidBanner />
        </div>
        <div className={Style.ctaContainer}>
          <Link to={url} className={Style.secondaryCtaButton} onClick={onMoreInfoLinkClick}>
            {secondaryCtaText}
          </Link>
        </div>
      </div>
    </Link>
  );
};

CountdownBanner.propTypes = {
  bgImage: PropTypes.string,
  countdownTo: PropTypes.string,
  handleCountdownEnd: PropTypes.func,
  headline: PropTypes.string,
  url: PropTypes.string,
};

export default CountdownBanner;
